import { render, staticRenderFns } from "./FindPassword.vue?vue&type=template&id=56fd05cc&scoped=true"
import script from "./FindPassword.vue?vue&type=script&lang=js"
export * from "./FindPassword.vue?vue&type=script&lang=js"
import style0 from "./FindPassword.vue?vue&type=style&index=0&id=56fd05cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fd05cc",
  null
  
)

export default component.exports